module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAARCAYAAAAPFIbmAAAAAXNSR0IArs4c6QAAAQJJREFUKFOFksFKxDAQhudPS59kURQEaZKKvougHvQgKF72pA+jBw9exJV1EXVvLqVJSu++SpuRCpHVbXSOwzeZ//8zoD+qruvdruvOEWOMMQWACTPvD0LOOem9nxLRkdb6aQWqqmpbCDFj5hOt9aTf9AOy1m4R0TOAUynlfZDyDTnnNpj5FcCFlPJuWesX1DTNWtu2cyIaK6Vuf5vBYrEYZVnWA1dKqeshtzDGvAP4UEodxOKAc27EzHNmvtRa3wy+1DeNMesA3qKawmRZlptpmr5E3QXw35wCGBL33h8XRfG4kngA+79j5qkQ4jDP81n0Cqy1O0T0EL2CpdV7SZKcfQI4eW92egQ2CQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanhui.png
// module id = CuwH
// module chunks = 1